// removed by extract-text-webpack-plugin
module.exports = {"pageTitle":"PageTitle__pageTitle___19rR9","ellipsis":"PageTitle__ellipsis___1ZLP3","isLight":"PageTitle__isLight___27Vg5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/PageTitle/PageTitle.scss
// module id = 600
// module chunks = 0